export const TELEGRAM_USERNAME = "ntrade_pro";
export const TELEGRAM_BASE = `https://t.me/${TELEGRAM_USERNAME}`;

const messages = {
  default: "Hi, I opened the MarketEdge showroom and need help choosing the right access.",
  "foundation-group": "Hi, I opened the MarketEdge showroom and I want to start with Foundation Group. Can you help me join the onboarding?",
  "elite-learning-room": "Hi, I want to learn more about Elite Learning Room and understand if it fits my level.",
  "mirror-study-access": "Hi, I want to understand Mirror Study Access. Can you explain the setup and learning format?",
  "technical-indicator-lab": "Hi, I want access to Technical Indicator Lab. Can you show me how it works?",
  "otc-session-navigator": "Hi, I want access to OTC Session Navigator. Can you help me understand the onboarding?",
  "pro-analysis-suite": "Hi, I want to explore Pro Analysis Suite. Can you explain which format fits me better?",
  "binarex-assistant": "Hi, I want to start with BinareX Assistant. Can you help me get access?",
  "evo-market-algorithm": "Hi, I want access to Evo Market Algorithm. Can you explain how the multi-market analysis works?",
  "ultra-session-scanner": "Hi, I want Ultra Session Scanner access. Can you help me understand the setup?",
  "strategyx-lab": "Hi, I want access to StrategyX Lab. Can you explain the available strategies?",
  "nexus-vision": "Hi, I want access to Nexus Vision. Can you help me start with the software onboarding?",
  "confluence-analysis-app": "Hi, I want access to Confluence Analysis App. Can you show me how the analysis works?",
  "pocket-era": "Hi, I want to open Pocket Era mini-app. Can you help me get access?",
  "vertex-mt5-lab": "Hi, I want access to Vertex MT5 Lab. Can you explain the setup and modes?",
  "quant-research-algorithm": "Hi, I want to explore Quant Research Algorithm. Can you help me understand the risk settings and setup?",
  "individual-learning-session": "Hi, I want to request Individual Learning Session. Can we discuss the format?",
  "learning-access-code": "Hi, I revealed a MarketEdge learning access code. Can you help me apply it to onboarding?",
  "private-support": "Hi, I opened the MarketEdge showroom and need help choosing the right access.",
};

export const generateTelegramLink = (productId, codeRevealed = null) => {
  let msg = messages[productId] || messages.default;
  if (codeRevealed) {
    msg = `Hi, I revealed a MarketEdge learning access code: ${codeRevealed}. Can you help me apply it to onboarding?`;
  }
  return `${TELEGRAM_BASE}?text=${encodeURIComponent(msg)}`;
};
